// extracted by mini-css-extract-plugin
module.exports = {"ellipsis-title":"index-ellipsis-title-3tx-_","ellipsisTitle":"index-ellipsis-title-3tx-_","ellipsis-desc":"index-ellipsis-desc-2mbSV","ellipsisDesc":"index-ellipsis-desc-2mbSV"};